import App from "./App";
import ReactDOM from "react-dom";
import React from "react";
import Backend from "./utils/Backend";
import { BlockchainName, DevType } from "./typings";
import EventManager from "./utils/EventManager";

export default class Template {
  publicKey: string;
  userId: string;
  state: any;
  type: DevType;
  backend: Backend;
  eventManager: EventManager;
  selectedBlockchainName: BlockchainName = "kovan";

  constructor(publicKey: string, userId: string) {
    const keyType = publicKey.split("-")[0];

    if (keyType !== "pk") {
      throw "Invalid key type, key type needs to begin with pk";
    }

    this.publicKey = publicKey;
    this.type = publicKey.split("-")[1] as DevType;

    this.backend = new Backend(
      "https://us-central1-payment-gateway-7bee8.cloudfunctions.net"
    );
    this.userId = userId;
    this.eventManager = new EventManager();
  }

  create(tag: string) {
    ReactDOM.render(
      <App
        backend={this.backend}
        publicKey={this.publicKey}
        type={this.type}
        userId={this.userId}
        events={this.eventManager}
      />,
      document.getElementById(tag)
    );

    return { on: this.eventManager.on.bind(this.eventManager) };
  }
}
